import { useEffect, useState } from "react";

function TimesheetViewMode({ value = "total", onChange }) {
  const [activeView, setActiveView] = useState(value);

  useEffect(() => {
    setActiveView(value);
  }, [value]);

  const handleSelect = (view) => {
    setActiveView(view);
    if (onChange) {
      onChange(view);
    }
  };

  const getTabClass = (view) =>
    `w-[59px] h-[31px] rounded-[6px] flex items-center justify-center cursor-pointer
    font-OpenSansRegular font-[700] text-[14px] transition-colors duration-150
    ${activeView === view ? "bg-white text-black" : "bg-transparent text-black"}`;

  return (
    <div data-tour="ts-view" data-tour-view={activeView} className="w-[123px] h-[39px] bg-[#E5E5E8] rounded-[8px] p-[4px] flex items-center justify-between ">
      <div data-tour="ts-day" onClick={() => handleSelect("day")} className={getTabClass("day")}>
        Day
      </div>
      <div data-tour="ts-total" onClick={() => handleSelect("total")} className={getTabClass("total")}>
        Total
      </div>
    </div>
  );
}

export default TimesheetViewMode;
